import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { selectIsArabic } from '../store/selectors/language.selectors';

@Injectable({
  providedIn: 'root',
})
export class LegalPagesService {
  private store = inject(Store);
  private http = inject(HttpClient);

  isArabic$: Observable<boolean> = this.store.select(selectIsArabic);

  private destroy$ = new Subject<void>();

  getLegalHtmlPage(pageTitle: string): Observable<string> {
    return this.isArabic$.pipe(
      takeUntil(this.destroy$),
      switchMap((isAr) => {
        const lang = isAr ? 'ar' : 'en';
        return this.http.get(`html-pages/${pageTitle}.${lang}.html`, { responseType: 'text' });
      })
    );
  }
}
